import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import { FaArrowLeft} from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";

function ModalComponent({ isOpen, previous, onClose, children, title, size }) {
  const darktheme = useSelector((state) => state.features.settings.darktheme);

  return (
    <Modal
      className="rounded-[60px]"
      isOpen={isOpen}
      onClose={onClose}
      size={size ? size : "2xl"}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={12}
        backgroundColor={darktheme ? "#121212" : "#F2F4F7"}
        containerProps={{ justifyContent: "center" }}
        sx={{
          borderRadius: "16px",
          boxShadow: "2xl",
          width: "552px",
          paddingY: "16px",
        }}
        
      >
        <div
          className={`${
            darktheme ? "bg-kdark3" : "bg-white"
          } `}
        >
          <div className="flex py-2 px-5 relative items-center w-full ">
            {previous ? (
              <div
                onClick={onClose}
                className={`w-[36px] absolute cursor-pointer  h-[36px]  ${
                  darktheme ? "bg-black text-[#888a8b] " : "bg-[#F2F4F7] "
                } border-[.1px] rounded-full my-[1rem]  justify-center flex items-center`}
              >
                <FaArrowLeft
                  size={12}
                  className={`  ${
                    darktheme ? "text-[#888a8b] " : "text-[#050558] "
                  }`}
                />
              </div>
            ) : (
              <div
                onClick={onClose}
                className={`p-1 absolute cursor-pointer  ${
                  darktheme ? "bg-black text-[#888a8b] " : "bg-[#F2F4F7] "
                } border-[.1px] rounded-full my-[1rem]  justify-center flex items-center`}
              >
                <IoMdClose
                  size={20}
                  className={` ${
                    darktheme ? "text-[#888a8b] " : "text-[#050558] "
                  }`}
                />
              </div>
            )}
            <h4
              className={`text-center mx-auto ${
                darktheme ? "text-[#888a8b] " : "text-[#1c2024] "
              }`}
            >
              {title}
            </h4>
          </div>

          <ModalBody className="">{children}</ModalBody>
        </div>
      </ModalContent>
    </Modal>
  );
}

export default ModalComponent;
